var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useContext, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Form, Field, Input } from '../../../../components/Form';
import { AuthContext } from '../../../../components/FirebaseAuth';
import { FirebaseAuth, CloudFunctions } from "../../../../components/FirebaseAuth/firebase";
import Alert from '../../../../components/Alert';
import { isMfaRequired } from '../../../../libs/mfa';
import { authErrorMessage } from '../../../../libs/authErrors';
import UserPageLayout from '../../../../components/user/UserPageLayout';
import { Table, Button } from "react-bootstrap";
import Loader from '../../../../components/Loader';
var DeleteUser = function () {
    var title = "Delete Your Account";
    var _a = useState({
        hasError: false,
        error: null,
        value: null
    }), emailAddress = _a[0], setEmailAddress = _a[1];
    var authUser = useContext(AuthContext).authUser;
    var _b = useState({
        status: null,
        message: ''
    }), result = _b[0], setResult = _b[1];
    var _c = useState(false), inSubmit = _c[0], setInSubmit = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var _e = useState([]), ownedAccounts = _e[0], setOwnedAccounts = _e[1];
    useEffect(function () {
        var getOwnedAccounts = function () { return __awaiter(void 0, void 0, void 0, function () {
            var user, accountsRef, query, accountSnapshots, records;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        user = FirebaseAuth.auth().currentUser;
                        if (user === null) {
                            setLoading(false);
                            return [2 /*return*/];
                        }
                        accountsRef = FirebaseAuth.firestore().collection('accounts');
                        query = accountsRef.where('owner', '==', user.uid);
                        return [4 /*yield*/, query.get()];
                    case 1:
                        accountSnapshots = _a.sent();
                        records = [];
                        accountSnapshots.forEach(function (account) {
                            records.push({
                                id: account.id,
                                name: account.data().name,
                                subscriptionStatus: account.data().subscriptionStatus
                            });
                        });
                        setOwnedAccounts(records);
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        getOwnedAccounts();
    }, []);
    // Filter for active (non-canceled) accounts
    var activeOwnedAccounts = ownedAccounts.filter(function (account) { return account.subscriptionStatus !== undefined && account.subscriptionStatus !== "canceled"; });
    var canDeleteUser = activeOwnedAccounts.length === 0;
    return (_jsx(UserPageLayout, { title: title, children: loading ? (_jsx(Loader, {})) : (_jsxs(_Fragment, { children: [!canDeleteUser && (_jsxs(_Fragment, { children: [_jsx(Alert, { type: "danger", dismissible: false, message: "You cannot delete your profile while you are the owner of active accounts. Please close or cancel all accounts listed below before deleting your profile. If you need help with this process, please reach out to support@ltiaas.com" }), _jsx("h5", { children: "Your Active Accounts" }), _jsx("p", { children: "You must close each of these accounts before you can delete your profile:" }), _jsxs(Table, { striped: true, bordered: true, hover: true, size: "sm", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Account Name" }), _jsx("th", { children: "Account Id" }), _jsx("th", { children: "Status" }), _jsx("th", { children: "Actions" })] }) }), _jsx("tbody", { children: activeOwnedAccounts.map(function (account) { return (_jsxs("tr", { children: [_jsx("td", { children: account.name }), _jsx("td", { children: account.id }), _jsx("td", { children: account.subscriptionStatus }), _jsx("td", { children: _jsxs(Button, { href: '/account/' + account.id + '/billing/delete', variant: "danger", size: "sm", children: [_jsx("i", { className: "fas fa-trash" }), " Close Account"] }) })] }, account.id)); }) })] }), _jsx(Link, { className: "btn btn-secondary", to: "/user/profile", children: "Back to Profile" })] })), canDeleteUser && result.status === null &&
                    _jsx(Form, { handleSubmit: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                            var onCall, err_1;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        e.preventDefault();
                                        setInSubmit(true);
                                        if (!(emailAddress.value === ((_a = authUser.user) === null || _a === void 0 ? void 0 : _a.email))) return [3 /*break*/, 5];
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([1, 3, , 4]);
                                        onCall = CloudFunctions.httpsCallable('oncall');
                                        return [4 /*yield*/, onCall({
                                                name: "logUserDeletion",
                                                data: {}
                                            })];
                                    case 2:
                                        _b.sent();
                                        return [3 /*break*/, 4];
                                    case 3:
                                        err_1 = _b.sent();
                                        return [3 /*break*/, 4];
                                    case 4:
                                        authUser.user.delete().then(function () {
                                            setResult({
                                                status: true,
                                                message: 'Your account has been deleted.'
                                            });
                                            setInSubmit(false);
                                        }).catch(function (err) {
                                            // Deleting an account is a sensitive operation, so Firebase
                                            // demands a recent sign-in. This page never reauthenticated,
                                            // and enrolling a second factor makes the error far more
                                            // likely — so say what to do rather than dumping the raw
                                            // SDK message, which carries a docs URL and no instruction.
                                            if ((err === null || err === void 0 ? void 0 : err.code) === 'auth/requires-recent-login' || isMfaRequired(err)) {
                                                setResult({
                                                    status: false,
                                                    message: 'For your security, please sign out and sign back in, then delete your account.'
                                                });
                                                setInSubmit(false);
                                                return;
                                            }
                                            setResult({
                                                status: false,
                                                message: authErrorMessage(err === null || err === void 0 ? void 0 : err.code) || 'We could not delete your account.'
                                            });
                                            setInSubmit(false);
                                        });
                                        return [3 /*break*/, 6];
                                    case 5:
                                        setEmailAddress({
                                            hasError: true,
                                            error: 'The email address does not match your email address.',
                                            value: emailAddress.value
                                        });
                                        setInSubmit(false);
                                        _b.label = 6;
                                    case 6: return [2 /*return*/];
                                }
                            });
                        }); }, submitBtnText: 'DELETE', submitBtnStyle: 'danger', disabled: emailAddress.hasError || emailAddress.value === null || inSubmit, inSubmit: inSubmit, enableDefaultButtons: true, backToUrl: "/user/profile", children: _jsx(Field, { label: "Confirm Your Email", children: _jsx(Input, { type: "email", name: "email-address", hasError: emailAddress.hasError, error: emailAddress.error, minLen: 5, maxLen: 50, required: true, validRegex: "^[a-zA-Z0-9-_+\\.]*@[a-zA-Z0-9-_\\.]*\\.[a-zA-Z0-9-_\\.]*$", changeHandler: setEmailAddress }) }) }), canDeleteUser && result.status === false &&
                    _jsxs(_Fragment, { children: [_jsx(Alert, { type: "danger", dismissible: false, message: result.message }), _jsx("button", { className: "btn btn-primary mr-2", onClick: function () {
                                    setResult({
                                        status: null,
                                        message: ''
                                    });
                                }, children: "Try Again" }), _jsx(Link, { className: "btn btn-secondary", to: "/user/profile", children: "View Profile" })] }), canDeleteUser && result.status === true &&
                    _jsxs(_Fragment, { children: [_jsx(Alert, { type: "success", dismissible: false, message: result.message }), _jsx(Link, { className: "btn btn-primary", to: "/user/profile", children: "View Profile" })] })] })) }));
};
export default DeleteUser;
